import { FC } from "react";
import Carrossel from '../Carrossel';
import { NotificacaoElemento } from '.';

export interface NotificacoesCarrossel {
    notificacoes: NotificacaoElemento[];
    handleCloseDialog: any;
    openDialogCarrossel: boolean;
    onVisualizar: (id: number) => void;
}
const DialogCarrosselNotification: FC<NotificacoesCarrossel> = ({handleCloseDialog, notificacoes, openDialogCarrossel, onVisualizar}) => {
  
  const handleClose = () => {
    handleCloseDialog(notificacoes);
  };
  
  return (
      <Carrossel 
        openDialogCarrossel={true} 
        notificacoes={notificacoes} 
        onVisualizar={(id) => {
          onVisualizar(id)
        }}
        handleCloseDialog={() => {
          handleClose()
        }} 
      />  
  );
}

export default DialogCarrosselNotification;
